import DOM from '../Library/DOM';

class CalendarViewSwitch {
    constructor(switchSelector, cookieName, force = null) {
        this.checked = false;
        this.switch = DOM.getElement(switchSelector);
        if (!this.switch) return;
        this.cookieName = cookieName;

        this.switch.addEventListener('change', (e) => this.onSwitchChange(e));

        this.getInitState(force);
    }

    getInitState(force) {
        if (typeof force === 'boolean') {
            this.setState(force, true);
        } else {
            const cookieValue = Cookies.get(this.cookieName);
            const initialState = cookieValue !== undefined
                ? Boolean(+cookieValue)
                : this.switch.checked;

            this.setState(initialState);
        }
    }

    onSwitchChange(e) {
        const checked = e.target.checked;
        this.setState(checked);
        this.notifyListeners(checked);
    }

    setState(state, ignoreCookie = false) {
        this.switch.checked = state;
        this.checked = state;
        if (ignoreCookie) return;
        Cookies.set(this.cookieName, +state);
    }

    /** @param {function} callback
     * calls callback(this.checked)
     * */
    addViewChangeListener(callback) {
        if (!this.callbacks) this.callbacks = [];
        this.callbacks.push(callback);
    }

    notifyListeners() {
        if (this.callbacks) {
            this.callbacks.forEach((callback) => {
                callback(this.checked);
            });
        }
    }
}

export default CalendarViewSwitch;
